"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useAddresses_1 = __importDefault(require("./hooks/useAddresses"));
// @ts-ignore
const react_bootstrap_typeahead_1 = require("react-bootstrap-typeahead");
const tech_1 = require("../../../../../tech");
function AddressSearchBar({ map }) {
    const [singleSelections, setSingleSelections] = (0, react_1.useState)([]);
    const [options, setOptions] = (0, react_1.useState)([]);
    const { fetchAddresses } = (0, useAddresses_1.default)();
    const { activeLau } = (0, tech_1.useAuth)();
    (0, react_1.useEffect)(() => {
        if (!activeLau) {
            console.error("No active lau (address search bar)");
            return;
        }
        fetchAddresses(activeLau.id).then((result) => {
            // console.log(result);
            const typed = result.map((address) => {
                return {
                    label: address.searchString,
                    coordinates: address.location
                };
            });
            setOptions(typed);
        });
    }, []);
    const onSearchClick = () => {
        if (singleSelections.length == 0) {
            return;
        }
        // @ts-ignore
        const a = singleSelections[0];
        if (a) {
            map.map.flyTo(a.coordinates, map.map.getMaxZoom());
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "input-group", style: {
            pointerEvents: "auto",
            width: "300px"
        }, children: [(0, jsx_runtime_1.jsx)("div", { className: "form-outline", style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(react_bootstrap_typeahead_1.Typeahead, { id: "basic-typeahead-single", 
                    // @ts-ignore
                    labelKey: (option) => option.label, 
                    // @ts-ignore
                    onChange: (e) => {
                        setSingleSelections(e);
                    }, options: options, placeholder: "Hledej adresu...", selected: singleSelections, emptyLabel: "\u017D\u00E1dn\u00E9 v\u00FDsledky", paginationText: "Dal\u0161\u00ED" }) }), (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary", onClick: onSearchClick, children: (0, jsx_runtime_1.jsx)("i", { className: "bi bi-search" }) })] }));
}
exports.default = AddressSearchBar;
